import React from 'react';
import { Box, Body, Icon, BoxProps } from '@hover/blueprint';
import { IconProp } from '@hover/icons';

interface Props extends BoxProps {
  title: string;
  icon: IconProp;
  iconColor?: string;
  titleColor?: string;
}

const JobPostBadge: React.FC<Props> = ({
  iconColor,
  titleColor,
  icon,
  title,
  ...rest
}) => (
  <Box
    w="auto"
    borderRadius="8px"
    py={100}
    {...rest}
    d="flex"
    alignItems="center"
    px={200}
  >
    <Box minW="24px" maxW="24px" mr={200}>
      <Icon icon={icon} size="default" m={0} color={iconColor} />
    </Box>
    <Body
      textTransform="uppercase"
      size={300}
      letterSpacing="1px"
      color={titleColor}
      isBold
    >
      {title}
    </Body>
  </Box>
);

JobPostBadge.defaultProps = {
  iconColor: 'brandNavy.500',
  titleColor: 'brandNavy.500',
};

export default JobPostBadge;
